/**
 * Lokale Spiegelung der Protokoll-Konstanten aus `@relyo/protocol`.
 *
 * Das SDK importiert vom Protokoll-Paket nur Typen, damit `zod` (Laufzeit-Abhängigkeit des
 * Protokolls) nicht im Browser-Bundle landet. `test/constants.test.ts` stellt sicher, dass die
 * Werte identisch zum Protokoll-Paket bleiben.
 */
export const PROTO_VERSION = 1;
export const HEARTBEAT_INTERVAL_MS = 20_000;
export const RR_BATCH_MS = 100;
export const RECONNECT_BACKOFF_MS = [1_000, 2_000, 4_000, 8_000] as const;
export const CODE_TTL_MS = 600_000;

/** Version dieses SDK (`device.hello.sdkVersion`). */
export const SDK_VERSION = '0.1.0';

/** rrweb `EventType` (aus `@rrweb/types`), hier als Zahl, um kein Enum zur Laufzeit zu laden. */
export const RR_EVENT_FULL_SNAPSHOT = 2;
export const RR_EVENT_META = 4;

export const STORAGE_DEVICE_ID = 'relyo.deviceId';
export const STORAGE_TAB_ID = 'relyo.tabId';
export const STORAGE_SESSION = 'relyo.session';
/** Vom Nutzer gewählte Position der Status-Pille (Issue #9). */
export const STORAGE_STATUS_POSITION = 'relyo.statusPosition';

/** Host-Element der SDK-Oberfläche; wird per `blockSelector` von der Aufzeichnung ausgenommen. */
export const HOST_ID = 'relyo-root';
export const HOST_SELECTOR = `#${HOST_ID}`;

/** Immer redaktierter Selektor (Spec Kap. 9). */
export const BASE_REDACT_SELECTOR = '.relyo-redact';
